/* Contenuti delle pagine pubbliche di prodotto (una per modulo). */
export const SOLUTIONS = [
  {
    slug: "utensili",
    path: "/soluzioni/utensili",
    nav: "Utensili",
    eyebrow: "MODULO · LOGISTICA UTENSILI",
    title: "Software per la gestione utensili in officina",
    metaTitle: "Software gestione utensili officina meccanica | ToolsValue",
    metaDescription:
      "Catalogo utensili e attacchi base, giacenze per magazzino, posizioni fisiche, movimenti tracciati, vita utile e costo per tagliente. Prova gratuita per officine di precisione.",
    teaser: "Catalogo tecnico, attacchi base, posizioni e consumi: ogni tagliente ha una storia consultabile.",
    intro:
      "In officina l'utensileria vale spesso più del magazzino materiali, ma viene gestita con fogli Excel e memoria degli operatori. Il modulo Logistica generale e utensili di ToolsValue mette a catalogo utensili, inserti e attacchi base con i loro dati tecnici, li lega alle lavorazioni e ne registra ogni movimento: sai sempre cosa hai, dove è e quanto ti costa.",
    image: "https://images.pexels.com/photos/20607184/pexels-photo-20607184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Fresa in lavorazione su un centro di lavoro CNC",
    highlights: [
      "Catalogo utensili e attacchi base",
      "Posizioni ed etichette con QR",
      "Movimenti carico, prelievo, reso",
      "Vita utile e costo per tagliente",
    ],
    sections: [
      {
        title: "Anagrafica tecnica, non un elenco di codici",
        paragraphs: [
          "Ogni utensile ha la sua scheda: codice aziendale, codice fornitore, geometria, materiale e rivestimento, numero di taglienti, parametri di taglio consigliati, foto e documenti del costruttore. La ricerca lavora su codice, descrizione, categoria e fornitore, così anche un nuovo arrivato trova l'utensile giusto senza chiedere.",
        ],
        bullets: [
          "Importazione da Excel o CSV del catalogo esistente, con mappatura delle colonne",
          "QR code sulla scheda per aprire la tracciabilità dal telefono",
          "Allegati: schede tecniche, foto del tagliente, certificati",
        ],
      },
      {
        title: "Attacchi base e assiemi macchina",
        paragraphs: [
          "Il corpo fresa, il portautensile e l'inserto sono articoli diversi con giacenze diverse. ToolsValue li tiene separati ma collegati: dalla scheda utensili di fase vedi la posizione in macchina, l'attacco base montato e la lunghezza utile, e la stessa informazione arriva all'operatore in officina.",
        ],
        bullets: [
          "Scheda utensili per fase con posizione in macchina e lunghezza utile",
          "Attacchi base con tipologia, cono e compatibilità macchina",
          "Segnalazione delle lavorazioni che usano un utensile fuori scheda",
        ],
      },
      {
        title: "Consumi, vita utile e costo reale",
        paragraphs: [
          "Ogni prelievo collegato alla commessa o alla macchina diventa un dato di consumo. Dopo poche settimane sai quanti taglienti costa un pezzo, quali utensili si consumano più del previsto e quali fornitori durano davvero: il preventivo smette di essere una stima a sentimento.",
        ],
        bullets: [
          "Consumo taglienti per componente, fase e macchina",
          "Vita residua e grado di usura sull'utensile",
          "Riordini proposti automaticamente sotto la scorta minima",
        ],
      },
    ],
    steps: [
      "Carichi il catalogo esistente da Excel o lo crei articolo per articolo.",
      "Assegni magazzino e posizione fisica a ogni utensile e attacco base.",
      "L'officina registra prelievi e resi dal terminale, con commessa e macchina.",
      "Consumi, scorte e riordini si aggiornano da soli e finiscono nei report.",
    ],
    faq: [
      {
        q: "Posso importare il catalogo utensili che ho già in Excel?",
        a: "Sì. L'importazione guidata legge il tuo file, ti fa scegliere quale colonna corrisponde a quale campo e mostra un'anteprima con gli errori prima di scrivere qualsiasi dato.",
      },
      {
        q: "Gli operatori devono imparare a usare un software complesso?",
        a: "No. In officina servono due gesti: cercare l'utensile e registrare prelievo o reso. La schermata di officina è pensata per un tablet a bordo macchina e i permessi limitano ciò che ogni ruolo vede.",
      },
      {
        q: "Come tengo traccia degli inserti sullo stesso corpo fresa?",
        a: "Corpo e inserto sono articoli distinti con giacenze proprie, collegati tra loro nell'assieme: consumi gli inserti senza perdere la storia del portautensile.",
      },
    ],
    related: ["magazzino", "produzione"],
  },
  {
    slug: "magazzino",
    path: "/soluzioni/magazzino",
    nav: "Magazzino",
    eyebrow: "MODULO · MAGAZZINI E GIACENZE",
    title: "Gestione magazzino utensili con più sedi e posizioni",
    metaTitle: "Gestione magazzino utensili multi-sede | ToolsValue",
    metaDescription:
      "Magazzini per sede e reparto, posizioni fisiche, giacenze divise per magazzino, trasferimenti, scorte minime e riordini automatici per officine meccaniche.",
    teaser: "Più magazzini, posizioni scritte, trasferimenti e scorte minime dove l'utensile serve davvero.",
    intro:
      "Una scorta \"a magazzino\" non serve se il pezzo è nell'altra sede. ToolsValue divide le giacenze per magazzino e reparto, ricorda la posizione fisica di ogni articolo, registra i trasferimenti e ti avvisa quando la soglia scende proprio nel magazzino dove la macchina sta lavorando.",
    image: "https://images.pexels.com/photos/5090651/pexels-photo-5090651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Scaffalature metalliche di un magazzino di officina",
    highlights: [
      "Magazzini per sede e reparto",
      "Posizione fisica per articolo",
      "Trasferimenti tra magazzini",
      "Scorta minima per magazzino",
    ],
    sections: [
      {
        title: "Un magazzino per come lavori davvero",
        paragraphs: [
          "Crei i magazzini che ti servono — centrale, reparto tornitura, carrello di una macchina, seconda sede — e li colleghi alla sede aziendale. Ogni articolo può stare in più magazzini con quantità e posizione diverse; il totale aziendale resta visibile, ma la ripartizione è quella reale.",
        ],
        bullets: [
          "Codice e nome del magazzino, collegati alla sede",
          "Posizione scritta come la leggono gli operatori (scaffale, ripiano, cassetto)",
          "Etichette stampabili con QR, codice articolo e posizione",
        ],
      },
      {
        title: "Movimenti e trasferimenti tracciati",
        paragraphs: [
          "Carico, prelievo, reso e rettifica passano sempre da un magazzino: chi ha preso cosa, quando e da dove è una domanda con risposta. Il trasferimento sposta la giacenza tra due magazzini senza inventare movimenti fittizi, così spesso scopri che il pezzo esiste già a trenta chilometri e non serve comprarlo.",
        ],
        bullets: [
          "Registro movimenti con autore, data, magazzino e sede",
          "Prelievo bloccato se il magazzino scelto non ha giacenza",
          "Eliminazione di un magazzino con spostamento guidato delle giacenze",
        ],
      },
      {
        title: "Scorte minime e riordini",
        paragraphs: [
          "La soglia si imposta sull'azienda e sul singolo magazzino: l'avviso arriva quando la giacenza scende dove l'utensile viene consumato, non quando il totale è a zero. Dalla lista riordini generi la proposta d'acquisto con la quantità da reintegrare e il fornitore abituale.",
        ],
        bullets: [
          "Avviso sotto scorta per singolo magazzino",
          "Proposte di riordino con quantità e fornitore",
          "Export Excel di giacenze, movimenti e consumi",
        ],
      },
    ],
    steps: [
      "Definisci i magazzini e li colleghi alle sedi aziendali.",
      "Assegni articoli, quantità e posizione a ciascun magazzino.",
      "Stampi le etichette con QR e le attacchi a scaffali e cassetti.",
      "Imposti le soglie e ricevi gli avvisi di sotto scorta dove serve.",
    ],
    faq: [
      {
        q: "Posso gestire due sedi con magazzini separati?",
        a: "Sì. Ogni magazzino appartiene a una sede: giacenze, movimenti e avvisi restano distinti, ma la direzione vede il quadro complessivo.",
      },
      {
        q: "Cosa succede se elimino un magazzino?",
        a: "Scegli tu: spostare le giacenze in un altro magazzino oppure lasciarle come quantità non assegnate nel totale dell'articolo. Nessun dato viene perso silenziosamente.",
      },
      {
        q: "Le etichette con QR servono a qualcosa in pratica?",
        a: "Inquadrando il QR sul cassetto si apre la scheda dell'articolo con giacenza, posizione e storico: elimina la domanda \"dov'è finito?\" a metà turno.",
      },
    ],
    related: ["utensili", "produzione"],
  },
  {
    slug: "acquisti",
    path: "/soluzioni/acquisti",
    nav: "Acquisti",
    eyebrow: "MODULO · ACQUISTI E FORNITORI",
    title: "Software acquisti e fornitori per officine meccaniche",
    metaTitle: "Software acquisti officina meccanica: fornitori e riordini | ToolsValue",
    metaDescription:
      "Anagrafica fornitori con listini e lead time, proposte di riordino su utensili, materie prime e ricambi, ordini di acquisto numerati e arrivo merce che carica il magazzino. Moduli dei piani Standard e Premium.",
    teaser: "Fornitori, listini, proposte di riordino, ordini e arrivo merce: il ciclo passivo che carica il magazzino.",
    intro:
      "Nella maggior parte delle officine gli acquisti nascono da un post-it o da una telefonata: si ordina quando l'utensile è già finito e si scopre il prezzo quando arriva la fattura. Il modulo Acquisti e fornitori di ToolsValue collega la scorta minima al fornitore giusto: propone il riordino, genera l'ordine con i prezzi del listino e, all'arrivo della merce, carica la giacenza nel magazzino e scrive il movimento. È incluso nei piani Standard e Premium.",
    image: "https://images.unsplash.com/photo-1763926062529-1edf8664c366?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGJhcnMlMjB3YXJlaG91c2UlMjBkZWxpdmVyeXxlbnwwfHx8fDE3ODgyOTE4OTZ8MA&ixlib=rb-4.1.0&q=85",
    imageAlt: "Barre di metallo accatastate in un magazzino industriale",
    highlights: [
      "Fornitori con listini, lead time e puntualità",
      "Proposte di riordino sotto la scorta minima",
      "Ordini ODA con IVA, stampa e invio email",
      "Arrivo merce che carica giacenze e movimenti",
    ],
    sections: [
      {
        title: "Fornitori con listini, non solo un numero di telefono",
        paragraphs: [
          "Ogni fornitore ha la sua scheda: categorie di fornitura, partita IVA e indirizzo, condizioni di pagamento, lead time, minimo d'ordine e MOQ, valuta, contatti, certificazioni e valutazione. La puntualità non la scrivi tu: si calcola dagli arrivi registrati. Il listino si carica da Excel o CSV, con aggancio automatico agli articoli già in anagrafica, sostituzione integrale o aggiornamento incrementale.",
        ],
        bullets: [
          "Codice progressivo FOR-NNNN e storico ordini con spesa per fornitore",
          "Listini con prezzo, sconto, netto, codice articolo del fornitore e validità dal/al",
          "Import del listino da Excel o CSV, anche con punto e virgola (Excel italiano)",
        ],
      },
      {
        title: "Proposte di riordino su tutto quello che consumi",
        paragraphs: [
          "Il motore delle proposte confronta giacenza e scorta minima su utensili, attacchi base, materie prime e articoli d'acquisto (ricambi, consumabili, accessori, attrezzature) e propone il riordino con il fornitore preferito e la quantità utile. Le proposte manuali coprono i casi che nascono in officina, come il ricambio di manutenzione. Da un elenco di proposte generi gli ordini raggruppati per fornitore.",
        ],
        bullets: [
          "Riordini su quattro tipi di articolo, con fornitore preferito e ultimo prezzo",
          "Proposte manuali, scarto motivato e generazione ordini per fornitore",
          "Articoli d'acquisto con unità di misura propria e giacenza reale a magazzino",
        ],
      },
      {
        title: "Ordini, IVA, stampa e arrivo merce",
        paragraphs: [
          "L'ordine di acquisto ha numerazione protetta ODA-AAAA-NNNN, testata con fornitore, date, riferimento, pagamento e spedizione, righe con articolo di qualsiasi tipo o descrizione libera, prezzo e sconto presi dal listino (l'origine del prezzo è sempre visibile) e aliquota IVA in testata. Lo mandi al fornitore in PDF con la tua carta intestata o via email. Quando la merce arriva registri l'arrivo, parziale o a saldo: la giacenza si carica nel magazzino indicato e nel registro movimenti compare un carico tracciato.",
        ],
        bullets: [
          "Stati bozza, confermato, ricevuto e chiuso con storico completo",
          "Prezzi dal listino, dall'anagrafica o digitati a mano, con origine dichiarata",
          "Arrivi parziali con documento e data, decimali per kg, metri e litri",
        ],
      },
    ],
    steps: [
      "Carichi l'anagrafica fornitori e i listini da Excel, oppure li compili riga per riga.",
      "Imposti scorta minima e fornitore preferito su utensili, materie prime e ricambi.",
      "Approvi le proposte di riordino e generi gli ordini raggruppati per fornitore.",
      "Registri l'arrivo merce: la giacenza si carica e il movimento resta tracciato.",
    ],
    faq: [
      {
        q: "In quali piani è incluso il modulo Acquisti e fornitori?",
        a: "Nei piani Standard e Premium. Con i piani Free e Easy Tool la voce resta visibile nel menu ma bloccata, e le API rispondono che il modulo non è attivo.",
      },
      {
        q: "Posso importare il listino del mio fornitore di utensili?",
        a: "Sì: dalla scheda fornitore carichi il file Excel o CSV, il sistema aggancia le righe agli articoli già in anagrafica (utensili, attacchi base, articoli d'acquisto) e puoi scegliere se sostituire tutto il listino o aggiornarlo in modo incrementale.",
      },
      {
        q: "L'arrivo merce aggiorna il magazzino da solo?",
        a: "Sì. L'arrivo aggiorna il ricevuto della riga d'ordine, carica la giacenza nel magazzino indicato sulla riga e scrive un movimento di carico nel registro, con documento e data del fornitore.",
      },
      {
        q: "Come si calcola la puntualità di un fornitore?",
        a: "Dagli arrivi registrati: si confronta la data prevista della riga d'ordine con la data dell'arrivo. Alla valutazione manuale (i voti che dai tu) si aggiunge così un dato oggettivo che non dipende dalla memoria.",
      },
    ],
    related: ["utensili", "magazzino"],
  },
  {
    slug: "produzione",
    path: "/soluzioni/produzione",
    nav: "Produzione",
    eyebrow: "MODULO · PIANIFICAZIONE PRODUZIONE",
    title: "Pianificazione della produzione per officine meccaniche",
    metaTitle: "Software pianificazione produzione officina meccanica | ToolsValue",
    metaDescription:
      "Commesse, componenti e fasi su planner e kanban, avanzamento di officina con cronometro, ore reali contro tempi previsti, report di chiusura commessa ed efficienza fasi.",
    teaser: "Commesse, fasi, planner e avanzamento di officina: tempi previsti e ore reali sullo stesso schermo.",
    intro:
      "Sapere quando consegnare non è una questione di intuito. ToolsValue porta commesse, componenti e fasi su un planner leggibile, raccoglie l'avanzamento direttamente dal bordo macchina e confronta il tempo preventivato con le ore realmente impiegate, fase per fase.",
    image: "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    imageAlt: "Lavorazione meccanica con scintille su una macchina utensile",
    highlights: [
      "Planner e kanban delle fasi",
      "Cronometro di officina",
      "Report di chiusura commessa",
      "Efficienza per macchina e reparto",
    ],
    sections: [
      {
        title: "Dalla commessa alla fase, senza fogli volanti",
        paragraphs: [
          "Ogni commessa contiene componenti e lotti; ogni componente il suo ciclo di lavoro con fasi, macchina, attrezzaggio e tempo ciclo. Il planner mostra i carichi di macchine e operatori, evidenzia i conflitti di capacità e permette di ripianificare trascinando una fase.",
        ],
        bullets: [
          "Ciclo di lavoro generato dallo standard o costruito fase per fase",
          "Kanban degli stati e tabella fasi con filtri",
          "Allegati di commessa: disegni, ordini, conferme",
        ],
      },
      {
        title: "L'officina registra, il sistema calcola",
        paragraphs: [
          "L'operatore avvia e sospende la fase con due pulsanti e dichiara pezzi buoni e scarti. Da quegli eventi ToolsValue ricostruisce le ore reali di lavorazione, tronca gli intervalli dimenticati aperti e segnala in cima alla pagina le fasi ancora in corso: il capoturno vede subito chi sta lavorando.",
        ],
        bullets: [
          "Ore reali dal cronometro, correggibili a mano quando serve",
          "Banner delle fasi avviate e avviso di turno lasciato aperto",
          "Blocchi di fase con motivo e responsabile",
        ],
      },
      {
        title: "Report di chiusura ed efficienza",
        paragraphs: [
          "A commessa completata il report confronta ore pianificate e ore consuntivate, pezzi buoni e scarti, con il delta in ore e in percentuale. La pagina Efficienza fasi aggrega gli sforamenti per macchina e reparto e mostra la classifica dei ritardi maggiori: sai dove ritarare i tempi standard.",
        ],
        bullets: [
          "Report chiusura commesse con export Excel",
          "Percentuale di scarto per componente e fase",
          "Storico attività: chi ha fatto cosa e quando",
        ],
      },
    ],
    steps: [
      "Crei la commessa con cliente, componenti, quantità e date.",
      "Generi le fasi dal ciclo standard e le distribuisci sul planner.",
      "L'officina avvia, sospende e dichiara l'avanzamento a bordo macchina.",
      "Chiudi la commessa e leggi il report: ore, pezzi, scarti e delta.",
    ],
    faq: [
      {
        q: "Devo installare terminali dedicati in officina?",
        a: "No. Basta un tablet o un PC con browser: la pagina di avanzamento è pensata per essere usata in piedi, con pulsanti grandi e pochi campi.",
      },
      {
        q: "Le ore reali sono affidabili se qualcuno dimentica di sospendere?",
        a: "Gli intervalli oltre un turno vengono troncati e segnalati, e le fasi rimaste aperte compaiono in evidenza. Il valore automatico resta correggibile a mano fase per fase.",
      },
      {
        q: "Posso capire quali lavorazioni mi fanno perdere margine?",
        a: "Sì: il report di chiusura e la pagina Efficienza fasi mostrano lo scostamento tra previsto e reale per fase, macchina e reparto, con export in Excel.",
      },
    ],
    related: ["qualita", "preventivazione"],
  },
  {
    slug: "qualita",
    path: "/soluzioni/qualita",
    nav: "Qualità",
    eyebrow: "MODULO · CONTROLLO QUALITÀ",
    title: "Controllo qualità e non conformità per la meccanica di precisione",
    metaTitle: "Software controllo qualità officina meccanica | ToolsValue",
    metaDescription:
      "Piani di controllo, quote misurate, strumenti e tarature, non conformità, azioni correttive e report di direzione per officine di meccanica di precisione.",
    teaser: "Piani di controllo, quote misurate, non conformità e azioni correttive collegate al pezzo.",
    intro:
      "Il controllo qualità serve a due cose: consegnare pezzi conformi e dimostrare di averlo fatto. Il modulo Qualità di ToolsValue tiene insieme piani di controllo, misure rilevate, strumenti con le loro tarature, non conformità e azioni correttive, sempre collegati al componente e alla fase che li ha generati.",
    image: "https://images.pexels.com/photos/16630111/pexels-photo-16630111.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Calibro di precisione appoggiato su una macchina utensile",
    highlights: [
      "Piani di controllo per componente",
      "Andamento quote e tolleranze",
      "Non conformità e azioni correttive",
      "Report per la direzione",
    ],
    sections: [
      {
        title: "Piani di controllo legati al componente",
        paragraphs: [
          "Il piano di controllo nasce dal disegno: quote, tolleranze, frequenza di controllo, strumento da usare e responsabile. È collegato al componente e alla fase, quindi l'operatore trova il piano giusto senza cercare la cartella condivisa, e ogni stampa riporta revisione, numero di disegno e fase.",
        ],
        bullets: [
          "Quote con tolleranza, frequenza e strumento previsto",
          "Revisioni tracciate del piano di controllo",
          "Stampa del piano e del rapporto di controllo",
        ],
      },
      {
        title: "Misure, strumenti e andamento delle quote",
        paragraphs: [
          "Le quote misurate finiscono in un unico registro: vedi l'andamento nel tempo, quanto sei vicino al limite di tolleranza e su quali pezzi la deriva è iniziata. Gli strumenti di misura hanno la loro anagrafica con scadenza di taratura e avvisi prima che scada.",
        ],
        bullets: [
          "Grafico di andamento per singola quota",
          "Strumenti con taratura, scadenza e avvisi",
          "Rapporti di controllo esportabili e stampabili",
        ],
      },
      {
        title: "Non conformità, azioni correttive, direzione",
        paragraphs: [
          "Una non conformità si apre dal pezzo o dalla fase, porta con sé causa, responsabile e costo, e resta aperta finché l'azione correttiva non è chiusa e verificata. Il report di direzione riassume andamento delle non conformità, scarti e azioni: il materiale che serve al riesame annuale, già pronto.",
        ],
        bullets: [
          "Registro non conformità con allegati e certificati",
          "Azioni correttive con scadenza e verifica di efficacia",
          "Audit log di tutte le operazioni di qualità",
        ],
      },
    ],
    steps: [
      "Definisci il piano di controllo del componente, quota per quota.",
      "L'officina registra le misure con lo strumento indicato.",
      "Le deviazioni aprono una non conformità con causa e responsabile.",
      "Le azioni correttive vengono chiuse e finiscono nel report di direzione.",
    ],
    faq: [
      {
        q: "Il modulo Qualità è incluso in tutti i piani?",
        a: "È incluso nel piano Premium. Puoi provarlo gratuitamente durante i 30 giorni di prova, senza carta di credito.",
      },
      {
        q: "Serve per la certificazione ISO 9001?",
        a: "ToolsValue non certifica al posto tuo, ma tiene ordinati i documenti che l'ente chiede: piani di controllo, registrazioni delle misure, non conformità, azioni correttive, tarature e riesame di direzione.",
      },
      {
        q: "Posso allegare i certificati del materiale?",
        a: "Sì: certificati, rapporti e foto si allegano al controllo o alla non conformità, con formati e dimensioni verificati dal sistema.",
      },
    ],
    related: ["produzione", "utensili"],
  },
  {
    slug: "preventivazione",
    path: "/soluzioni/preventivazione",
    nav: "Preventivi",
    eyebrow: "MODULO · PREVENTIVAZIONE",
    title: "Software di preventivazione per officine meccaniche",
    metaTitle: "Software preventivi officina meccanica: costi e margini | ToolsValue",
    metaDescription:
      "Calcola tempi, costo industriale, margine e prezzo di vendita dei tuoi pezzi: preventivo rapido dai parametri di taglio o dalle fasi del ciclo, fasi esterne, offerta in PDF e confronto con il consuntivo. Modulo del piano Premium.",
    teaser: "Dal disegno al prezzo: tempi e costi calcolati, margine deciso da te, offerta pronta in PDF.",
    intro:
      "Il preventivo è il momento in cui si decide il margine di una commessa, ma nella maggior parte delle officine nasce su un foglio Excel personale, con tempi stimati a memoria e tariffe vecchie di due anni. Il modulo Preventivazione di ToolsValue calcola i tempi dalle geometrie e dai parametri di taglio (oppure dalle fasi del tuo ciclo), applica la tariffa oraria di ogni macchina e ti mostra costo industriale, margine e prezzo proposto mentre scrivi. È incluso nel piano Premium.",
    image: "https://images.pexels.com/photos/5915138/pexels-photo-5915138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    imageAlt: "Calcolo dei costi con la calcolatrice su un disegno tecnico",
    highlights: [
      "Tempi e costi calcolati, non stimati a memoria",
      "Costo industriale, margine e prezzo per più quantità",
      "Offerta PDF per il cliente e stampa interna con i costi",
      "Confronto fra preventivo e ore reali di officina",
    ],
    sections: [
      {
        title: "Due strade per arrivare al prezzo",
        paragraphs: [
          "Il preventivo rapido parte da geometrie e parametri di taglio: fori, spianature, tornitura, filettature, maschiature. Scrivi diametro, profondità, lunghezze e ripetizioni e il sistema calcola giri, avanzamento, tempo di taglio e tempi accessori con le stesse formule che usi al banco. Se il componente ha già un ciclo di lavoro, il preventivo analitico importa l'elenco delle fasi: a te resta da indicare attrezzaggio e tempo ciclo, il resto si valorizza da solo.",
        ],
        bullets: [
          "Sette tipi di lavorazione con parametri e geometrie dedicate",
          "Fasi importate dal ciclo del componente con la macchina suggerita",
          "Maggiorazione prudenziale ed efficienza produttiva configurabili",
        ],
      },
      {
        title: "Ogni macchina con la sua tariffa oraria",
        paragraphs: [
          "Una fresa a 5 assi non costa come un trapano a colonna. Ogni macchina ha la sua tariffa oraria, con l'opzione «operatore compreso», e i valori predefiniti aziendali coprono i casi che non hai ancora impostato. Il preventivo dichiara sempre quali dati mancano e con un indicatore di affidabilità ti dice se è una stima preliminare o un calcolo su cui puoi firmare.",
        ],
        bullets: [
          "Tariffa oraria per macchina e tariffa operatore separata",
          "Costo utensile come percentuale del costo macchina o importo a mano",
          "Indicatore di affidabilità con l'elenco dei dati mancanti",
        ],
      },
      {
        title: "Fasi esterne, quantità alternative e margine",
        paragraphs: [
          "Taglio del grezzo, rettifica, trattamenti termici e superficiali, collaudi: le fasi affidate ai fornitori entrano nel costo con prezzo a pezzo, a lotto, a kg, a ora o una tantum, minimo di fatturazione, ricarico e giorni di consegna che allungano la data promessa al cliente. Puoi confrontare fino a quattro quantità in una schermata e vedere come cambiano prezzo unitario, margine e consegna.",
        ],
        bullets: [
          "Fasi esterne con fornitore, minimo di fatturazione e ricarico",
          "Confronto prezzi su più quantità in un colpo d'occhio",
          "Costi indiretti, rischio, sconto e margine obiettivo governati da te",
        ],
      },
      {
        title: "Offerta in PDF, revisioni e consuntivo",
        paragraphs: [
          "Con un clic ottieni due documenti: l'offerta per il cliente, con il tuo logo, i prezzi per quantità e il ciclo previsto senza nessun costo interno, e la stampa interna con tempi, tariffe, ripartizione dei costi e margine. Il preventivo approvato si congela: per modificarlo si crea una nuova revisione e le tariffe storicizzate restano quelle del giorno dell'offerta. Quando il cliente accetta, dal preventivo nasce la commessa e a fine lavoro confronti ore e costi preventivati con quelli reali di officina.",
        ],
        bullets: [
          "Offerta PDF con logo aziendale e stampa interna analitica",
          "Stati, approvazioni e revisioni immutabili tracciate",
          "Commessa generata dal preventivo accettato, con le fasi già pronte",
          "Confronto preventivo/consuntivo su ore, costi e margine reale",
        ],
      },
    ],
    steps: [
      "Imposti tariffe orarie, maggiorazioni, margine obiettivo e numerazione delle offerte.",
      "Crei il preventivo: geometrie e parametri di taglio, oppure le fasi del ciclo del componente.",
      "Leggi costo industriale, margine, prezzo e consegna mentre scrivi, anche su più quantità.",
      "Approvi, mandi l'offerta in PDF e, a lavoro finito, confronti il preventivo con il consuntivo.",
    ],
    faq: [
      {
        q: "In quale piano è incluso il modulo Preventivazione?",
        a: "Nel piano Premium, insieme ai moduli Qualità e Controllo di gestione e agli utenti illimitati. Puoi provarlo durante i 30 giorni di prova senza carta di credito; con i piani Free, Easy Tool e Standard il modulo resta visibile ma bloccato.",
      },
      {
        q: "Devo conoscere i parametri di taglio per fare un preventivo?",
        a: "No. Se non li scrivi, il sistema usa i valori predefiniti dell'azienda o la velocità di taglio del materiale e ti segnala che il dato è stimato. In alternativa parti dalle fasi del ciclo e indichi solo attrezzaggio e tempo ciclo.",
      },
      {
        q: "Il cliente vede i miei costi e i miei margini?",
        a: "Mai. L'offerta PDF per il cliente mostra soltanto quantità, prezzi, consegna, condizioni e note; costi, tariffe, margini e nomi dei fornitori restano nella stampa interna, riservata a chi ha il permesso di vedere i costi.",
      },
      {
        q: "Posso capire se ho preventivato bene?",
        a: "Sì: dal preventivo accettato generi la commessa con le fasi e i tempi preventivati, l'officina timbra le lavorazioni e il preventivo mostra il confronto fra ore e costi previsti e reali, con il margine ricalcolato sul prezzo di vendita.",
      },
    ],
    related: ["produzione", "utensili"],
  },
];

export const findSolution = (slug) => SOLUTIONS.find((item) => item.slug === slug);
